import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import { HighchartsChart, Chart, XAxis, withHighcharts, YAxis, PlotLine, ColumnSeries, } from 'react-jsx-highcharts';
import { Button } from '../Button';
const NoiseGraphEL = ({ data, count, startTime, endTime, xPlotLines = [], languageData, hideResetZoomButton = false, }) => {
    const [columnData, setcolumnData] = useState([]);
    const [isZoomed, setIsZoomed] = useState(false);
    const plotOptions = {
        column: { grouping: false },
        series: {
            turboThreshold: 120000,
            animation: false,
            pointPadding: 0,
            groupPadding: 0,
            borderWidth: 0,
            opacity: 1,
            pointStart: 0,
            states: {
                hover: { enabled: false },
            },
        },
    };
    useEffect(() => {
        const newData = data.map(item => {
            if (item > 80) {
                return { y: item, color: '#430a4a' };
            }
            else if (item > 75) {
                return { y: item, color: '#75085c' };
            }
            else if (item > 70) {
                return { y: item, color: '#a11a4d' };
            }
            else if (item > 65) {
                return { y: item, color: '#cd463e' };
            }
            else if (item > 60) {
                return { y: item, color: '#e87e4d' };
            }
            else if (item > 55) {
                return { y: item, color: '#f3c683' };
            }
            else if (item > 50) {
                return { y: item, color: '#e2f2bf' };
            }
            else if (item > 45) {
                return { y: item, color: '#cee4cc' };
            }
            else if (item > 40) {
                return { y: item, color: '#b8d6d1' };
            }
            else if (item > 35) {
                return { y: item, color: '#a0babf' };
            }
            return { y: item, color: '#82a6ad' };
        });
        setcolumnData(newData);
    }, [data]);
    const zoomOut = () => {
        if (chart) {
            chart.zoomOut();
        }
    };
    // Reset zoom if either extreme ends change
    useEffect(() => {
        zoomOut();
    }, [startTime, endTime]);
    const [chart, setChart] = useState();
    const setChartRef = (chart) => {
        setChart(chart);
    };
    useEffect(() => {
        if (chart) {
            chart.reflow();
        }
    });
    return (React.createElement("div", null,
        isZoomed && !hideResetZoomButton ? (React.createElement(Button, { className: "graph-zoomout-button", size: "s", style: "standard", onClick: zoomOut }, languageData.resetZoom)) : null,
        React.createElement(HighchartsChart, { plotOptions: plotOptions, callback: setChartRef },
            React.createElement(Chart, { panning: true, panKey: "shift", zoomType: "x", type: 'column', scrollablePlotArea: { scrollPositionX: 0 }, height: 72, marginBottom: 0, marginTop: 0, marginLeft: 12, marginRight: 12, padding: 0, resetZoomButton: {
                    position: {
                        align: 'left',
                        x: 0,
                        y: 0,
                    },
                    theme: {
                        fill: '#f4f7fb',
                        stroke: 'none',
                        r: 3,
                        style: {
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: 1.71,
                        },
                        states: {
                            hover: {
                                fill: '#c4cdd5',
                            },
                        },
                    },
                } }),
            React.createElement(XAxis, { min: 0.5, max: endTime - startTime - 0.5, gridLineWidth: 0, tickLength: 0, labels: { enabled: false } },
                React.createElement(PlotLine, { color: '#0856ca', value: count - startTime, width: 1, zIndex: 5 }),
                xPlotLines.map((value, idx) => (React.createElement(PlotLine, { key: `${value}_${idx}`, color: '#c4cdd5', value: value, width: 1, zIndex: 5 })))),
            React.createElement(YAxis, { endOnTick: false, startOnTick: false, maxPadding: 0, gridLineWidth: 0, min: 40, height: 60, top: 12, labels: { enabled: false } },
                React.createElement(ColumnSeries, { name: "Noise", data: columnData })))));
};
export const NoiseGraph = withHighcharts(NoiseGraphEL, Highcharts);
//# sourceMappingURL=NoiseGraph.js.map